import React, { Component } from "react";
import { shuffle, filter } from "lodash";
// import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// import okButtonIcon from "../../../../assets/images/okbutton_icon.png";
// import FlipMove from "react-flip-move";
import MMGCard from "./MMGCard";
import "./MMGTypeQuestion.scss";
import $ from "jquery";

//-----------------------------------------------------------------------------
// Multiple Match Graphics Question Type - MMG - Concentration Memory Game
//-----------------------------------------------------------------------------
class MMGTypeQuestion extends Component {
  constructor() {
    super();
    this.state = {
      generatedAnswers: [],
      currentQuestionDeductionScore: 0,
      matchedCardsList: [],
      openedCardsList: [],
      flippedCardsCount: 0,
      isAllCardsMatched: false,
    };
  }

  componentDidMount() {
    const { currentQuestion } = this.props;

    this.generateAnswersSet(
      currentQuestion.AData,
      currentQuestion.IsRandomAnswers,
      currentQuestion.QTypeShort,
      currentQuestion.ADataRandomLines
    );
    window.addEventListener("resize", this.manageCardsListHeight);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.currentQuestion !== nextProps.currentQuestion) {
      this.generateAnswersSet(
        nextProps.currentQuestion.AData,
        nextProps.currentQuestion.IsRandomAnswers,
        nextProps.currentQuestion.QTypeShort,
        nextProps.currentQuestion.ADataRandomLines
      );
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.manageCardsListHeight);
  }

  manageCardsListHeight = () => {
    let windowHeight = $(window).height();
    let documentHeight = $(document).height();
    if (documentHeight > windowHeight) {
      let mmgContainerHeight = $(".mmg-question-details").height();
      let mmgContainerWidth = $(".mmg-question-details").width();
      let expectedmmgHeight = windowHeight * 0.7;
      let newMMGContainerHeight = Math.round(
        (expectedmmgHeight * mmgContainerWidth) / mmgContainerHeight
      );
      $(".mmg-question-details").css(
        "cssText",
        "width: " + newMMGContainerHeight + "px !important;"
      );
      let cardFontSize = parseFloat($(".back").css("font-size"));
      let newCardFontSize = Math.round(
        (expectedmmgHeight * cardFontSize) / mmgContainerHeight
      );
      $(".back").css("font-size", newCardFontSize + "px");
    }
  };

  generateAnswersSet = (
    answerData,
    isRandomAnswers,
    questionType,
    randomLinesCount
  ) => {
    let generatedAnswersArray = [];
    generatedAnswersArray = filter(answerData.split("\n")).map(
      (item, index) => {
        let answerTypeSplittedArray = item.split("|");
        answerTypeSplittedArray = filter(answerTypeSplittedArray);
        if (answerTypeSplittedArray.length === 2) {
          let splittedArray = answerTypeSplittedArray[1].split("=");
          return splittedArray[0] !== ""
            ? {
                id: index + 1,
                pairMatch1: splittedArray[0],
                pairMatch2: splittedArray[1],
                match1Id: "match_" + index + "_1",
                match2Id: "match_" + index + "_2",
                answerType: answerTypeSplittedArray[0],
              }
            : null;
        } else {
          let splittedArray = answerTypeSplittedArray[0].split("=");
          return splittedArray[0] !== ""
            ? {
                id: index + 1,
                pairMatch1: splittedArray[0],
                pairMatch2: splittedArray[1],
                match1Id: "match_" + index + "_1",
                match2Id: "match_" + index + "_2",
                answerType: "T",
              }
            : null;
        }
      }
    );

    generatedAnswersArray = this.props.getRandomAnswers(
      filter(generatedAnswersArray),
      randomLinesCount
    );

    generatedAnswersArray.forEach((listItem, index) => {
      listItem.optionActualOrder = index + 1;
    });

    if (isRandomAnswers === "1") {
      generatedAnswersArray = shuffle(generatedAnswersArray);
    }
    let matchedCardsList = [];
    generatedAnswersArray.forEach((element, index) => {
      matchedCardsList.push({
        id: element.match1Id,
        matchingId: element.id,
        name: element.pairMatch1,
        answerType: "T",
        close: true,
        complete: false,
        fail: false,
      });
      matchedCardsList.push({
        id: element.match2Id,
        matchingId: element.id,
        name: element.pairMatch2,
        answerType: element.answerType,
        close: true,
        complete: false,
        fail: false,
      });
    });
    //shuffle all cards
    matchedCardsList = shuffle(matchedCardsList);
    this.setState(
      {
        generatedAnswers: generatedAnswersArray,
        matchedCardsList,
      },
      () => {
        this.manageCardsListHeight();
      }
    );
  };
  handleClick = (cardItem, index) => {
    const { flippedCardsCount } = this.state;
    if (this.state.openedCardsList.length === 2) {
      setTimeout(() => {
        this.checkCardMatching();
      }, 750);
    } else {
      let matchedCardsList = this.state.matchedCardsList;
      cardItem = { ...cardItem, index };
      let allCardsList = this.state.openedCardsList;
      matchedCardsList[index].close = false;
      allCardsList.push(cardItem);
      this.setState({
        openedCardsList: allCardsList,
        matchedCardsList: matchedCardsList,
      });
      if (this.state.openedCardsList.length === 2) {
        setTimeout(() => {
          this.checkCardMatching();
        }, 750);
      }
    }
    this.setState({
      flippedCardsCount: flippedCardsCount + 1,
    });
  };
  checkCardMatching = () => {
    if (this.state.openedCardsList.length === 2) {
      let matchedCardsList = this.state.matchedCardsList;
      if (
        this.state.openedCardsList[0].matchingId ===
          this.state.openedCardsList[1].matchingId &&
        this.state.openedCardsList[0].id !== this.state.openedCardsList[1].id
      ) {
        matchedCardsList[this.state.openedCardsList[0].index].complete = true;
        matchedCardsList[this.state.openedCardsList[1].index].complete = true;
      } else {
        matchedCardsList[this.state.openedCardsList[0].index].close = true;
        matchedCardsList[this.state.openedCardsList[1].index].close = true;
      }
      this.setState(
        {
          matchedCardsList,
          openedCardsList: [],
        },
        () => {
          this.verifyMMGAnswer();
        }
      );
    } else {
      this.verifyMMGAnswer();
    }
  };

  verifyMMGAnswer = () => {
    const { flippedCardsCount } = this.state;
    let { currentQuestion, currentQuestionId } = this.props;
    const expectedMatchedCount = this.state.generatedAnswers.length * 2;
    const actualMatchedCount = filter(this.state.matchedCardsList, {
      complete: true,
    }).length;
    let deductionPercentage = 0;
    if (expectedMatchedCount === actualMatchedCount) {
      if (flippedCardsCount > 0 && flippedCardsCount <= 24) {
        //Give 100% points
        deductionPercentage = 0;
      } else if (flippedCardsCount > 24 && flippedCardsCount <= 28) {
        //Give 90% points
        deductionPercentage = 10;
      } else if (flippedCardsCount > 28 && flippedCardsCount <= 32) {
        //Give 80% points
        deductionPercentage = 20;
      } else {
        //Give 0 points
        deductionPercentage = 100;
      }
      let questionDetails = {
        number: currentQuestionId,
        questionText: currentQuestion.QLong,
        QTypeShort: currentQuestion.QTypeShort,
        questionGraphicUrl: currentQuestion.QGraphicURL,
        correctAnswersCount: 6,
        expectedAnswersCount: 6,
        answers: [],
        deductionPercentage: deductionPercentage,
        isCorrect: 1,
      };
      this.props.addAttendedQuestion(questionDetails);
      this.setState({
        currentQuestionDeductionScore: 0,
        flippedCardsCount: 0,
      });
    }
  };

  getRemainingTriesText = () => {
    switch (this.state.currentQuestionDeductionScore) {
      case 0:
        return "";
      case 50:
        return "2 Attempts Remaining";
      /*
      case 20:
        return "5 Attempts Remaining";
      case 40:
        return "4 Attempts Remaining";
      case 60:
        return "3 Attempts Remaining";
      case 80:
        return "2 Attempt Remaining";
      */
      case 100:
        return "1 Attempt Remaining";
      default:
        return "";
    }
  };

  render() {
    // const { generatedAnswers } = this.state;
    const remainingTriesText = this.getRemainingTriesText();
    return (
      <div className="mmg-answer-options-container">
        {!this.props.isTest && remainingTriesText && (
          <div className="remaining-attempts-text remaining-attempt-pio">
            {remainingTriesText}
          </div>
        )}
        <div className="mmg-cards-list-container">
          {this.state.matchedCardsList.map((cardItem, index) => {
            return (
              <MMGCard
                key={"card_" + index}
                cardItem={cardItem}
                click={() => {
                  this.handleClick(cardItem, index);
                }}
                close={cardItem.close}
                complete={cardItem.complete}
                questionSetDetails={this.props.questionSetDetails}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

export default MMGTypeQuestion;
